import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchWishlist } from '../redux/store/wishlist';

const WishlistProvider = ({ children }) => {
  const dispatch = useDispatch();
  const { isLoggedIn } = useSelector((state) => state.user);
  const { wishlistItems } = useSelector((state) => state.wishlist);

  useEffect(() => {
    // Fetch wishlist when user logs in and wishlist is empty
    if (isLoggedIn && wishlistItems.length === 0) {
      dispatch(fetchWishlist());
    }
  }, [dispatch, isLoggedIn, wishlistItems.length]);

  return children;
};

export default WishlistProvider;